<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  show: Boolean,
  activeFilters: {
    type: Object,
    default: () => ({ type: [], status: [] })
  }
});

const emit = defineEmits(['close', 'apply']);

const localFilters = ref({ type: [], status: [] });

watch(() => props.show, (newVal) => {
  if (newVal) {
    // Clone active filters when opening modal
    localFilters.value = {
      type: [...props.activeFilters.type],
      status: [...props.activeFilters.status]
    };
  }
});

const applyFilters = () => {
  emit('apply', { ...localFilters.value });
};
</script>

<template>
  <div v-if="show" class="fixed inset-0 z-50 flex items-start justify-center bg-black/40 overflow-y-auto pt-24">
    <div class="bg-white dark:bg-n-solid-1 rounded-lg shadow-xl w-full max-w-3xl mx-4 overflow-hidden border border-n-slate-3">
      <div class="flex items-center justify-between p-4 border-b border-n-slate-3 bg-n-slate-1/50 dark:bg-n-solid-2/50">
        <h3 class="text-base font-semibold text-n-slate-12">Calls - Custom filter</h3>
        <button @click="emit('close')" class="text-n-slate-11 hover:text-n-slate-12 transition-colors">
          <span class="i-ph-x text-xl flex"></span>
        </button>
      </div>
      
      <div class="p-6 space-y-6">
        <!-- Type Filter -->
        <div class="grid grid-cols-12 gap-4 items-center border-b border-n-slate-3 pb-6">
          <div class="col-span-2 text-sm font-medium text-n-slate-12">Type</div>
          <div class="col-span-10 flex items-center gap-6">
            <label class="flex items-center gap-2 cursor-pointer group">
              <input type="checkbox" value="inbound" v-model="localFilters.type" class="w-4 h-4 rounded border-n-slate-4 text-[#1f93ff] focus:ring-[#1f93ff]">
              <span class="text-sm text-n-slate-12 group-hover:text-n-slate-11 transition-colors">Incoming</span>
            </label>
            <label class="flex items-center gap-2 cursor-pointer group">
              <input type="checkbox" value="outbound" v-model="localFilters.type" class="w-4 h-4 rounded border-n-slate-4 text-[#1f93ff] focus:ring-[#1f93ff]">
              <span class="text-sm text-n-slate-12 group-hover:text-n-slate-11 transition-colors">Outgoing</span>
            </label>
          </div>
        </div>

        <!-- Status Filter -->
        <div class="grid grid-cols-12 gap-4 items-center border-b border-n-slate-3 pb-6">
          <div class="col-span-2 text-sm font-medium text-n-slate-12">Status</div>
          <div class="col-span-10 flex flex-wrap items-center gap-6">
            <label class="flex items-center gap-2 cursor-pointer group">
              <input type="checkbox" value="missed" v-model="localFilters.status" class="w-4 h-4 rounded border-n-slate-4 text-[#1f93ff] focus:ring-[#1f93ff]">
              <span class="text-sm text-n-slate-12 group-hover:text-n-slate-11 transition-colors">Missed</span>
            </label>
            <label class="flex items-center gap-2 cursor-pointer group">
              <input type="checkbox" value="answered" v-model="localFilters.status" class="w-4 h-4 rounded border-n-slate-4 text-[#1f93ff] focus:ring-[#1f93ff]">
              <span class="text-sm text-n-slate-12 group-hover:text-n-slate-11 transition-colors">Answered</span>
            </label>
            <label class="flex items-center gap-2 cursor-pointer group">
              <input type="checkbox" value="completed" v-model="localFilters.status" class="w-4 h-4 rounded border-n-slate-4 text-[#1f93ff] focus:ring-[#1f93ff]">
              <span class="text-sm text-n-slate-12 group-hover:text-n-slate-11 transition-colors">Completed</span>
            </label>
            <label class="flex items-center gap-2 cursor-pointer group">
              <input type="checkbox" value="voicemail" v-model="localFilters.status" class="w-4 h-4 rounded border-n-slate-4 text-[#1f93ff] focus:ring-[#1f93ff]">
              <span class="text-sm text-n-slate-12 group-hover:text-n-slate-11 transition-colors">Voicemail</span>
            </label>
          </div>
        </div>
      </div>

      <div class="px-6 py-4 flex items-center gap-3">
        <button @click="applyFilters" class="px-5 py-2 bg-[#f2711c] hover:bg-[#e06b1a] text-white rounded font-medium shadow-sm transition-colors text-sm">
          Apply
        </button>
        <button @click="emit('close')" class="px-5 py-2 bg-white dark:bg-n-solid-1 border border-n-slate-4 hover:bg-n-slate-2 text-n-slate-12 rounded font-medium shadow-sm transition-colors text-sm">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>
